module.exports = __webpack_public_path__ + "static/media/img6.1750ff1e.jpg";